import React, {useState} from 'react'
import Box from '@mui/material/Box';
import BasicSnackbar from "../../components/common/BasicSnackbar/BasicSnackbar";
import ConversationMessages from "../../components/ConversationMessages/ConversationMessages";
import ConversationFilter from "../../components/ConversationFilter/ConversationFilter";

const drawerWidth = 240;
const CampaignViewer = () => {
    const [open, setOpen] = useState(false)
    const [campaign, setCampaign] = useState(null)
    const [account, setAccount] = useState(null)

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const onSelectCampaign = (e, campaign) => {
        e.preventDefault()
        // if (!campaign) return
        console.log(campaign)
        setCampaign(campaign)
    }

    const onSelectAccount = (e, account) => {
        e.preventDefault()
        // if (!account) return
        console.log(account)
        setAccount(account)
        setCampaign(null)
    }

    return (
        <Box
            component="main"
            sx={{flexGrow: 1, p: 3, width: {sm: `calc(100% - ${drawerWidth}px)`}, marginTop: '46px'}}
        >
            <ConversationFilter onError={() => setOpen(true)} account={account} campaign={campaign} onSelectAccount={onSelectAccount}
                                onSelect={onSelectCampaign}/>

            <ConversationMessages onError={() => setOpen(true)} campaign={campaign} account={account}/>

            <BasicSnackbar
                open={open}
                severity="error"
                message="Data couldn't be fetched"
                onClose={handleClose}
            />
        </Box>)
}

export default CampaignViewer